<template>
    <div class="miniStatsBox mt-4 h-100">
        <p>{{ title }}</p>
        <div>
            <p>{{ value }}</p>
            <div :style="{'background' : iconColor}">
                <i :class="icon"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {props : ['title', 'value', 'icon', 'iconColor']}
</script>

<style scoped>
    .miniStatsBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 25px 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    }

    .miniStatsBox > p {
        font-size: 24px;
        color: #4D4D4D;
        font-weight: bold;
        margin-bottom: 0;
    }

    .miniStatsBox > div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .miniStatsBox > div > p {
        font-size: 44px;
        color: #4D4D4D;
        font-weight: bold;
        margin-bottom: 0;
    }

    .miniStatsBox > div > div {
        background: #ABABAB;
        width: 75px;
        height: 75px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10000px;
    }

    .miniStatsBox > div > div > i {
        font-size: 43px;
        opacity: 0.8;
    }

</style>